<!-- Footer
  ============================================= -->
<footer id="footer" class="section bg-dark py-4">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 text-center text-lg-start">
                <p class="text-light mb-3 mb-lg-0">&copy; 2026 <span class="text-primary fw-500">Abdul Rahman
                        Haroon</span>. All Rights Reserved.</p>
            </div>
            <div class="col-lg-6">
                <ul
                    class="social-icons social-icons-light social-icons-sm justify-content-center justify-content-lg-end d-flex mb-0">
                    <li class="me-2"><a data-bs-toggle="tooltip" href="mailto:abdulrahman.haroonr@gmail.com"
                            target="_blank" aria-label="Email"><i class="fa-solid fa-envelope"></i></a></li>
                    <li class="me-2"><a data-bs-toggle="tooltip"
                            href="https://www.linkedin.com/in/abdul-rahman-haroon/" target="_blank"
                            aria-label="LinkedIn"><i class="fab fa-linkedin"></i></a></li>
                    <li><a data-bs-toggle="tooltip" href="https://github.com/abdulrahman-haroon" target="_blank"
                            aria-label="GitHub"><i class="fab fa-github"></i></a></li>
                </ul>
            </div>
        </div>
    </div>
</footer>
<!-- Footer end -->
